import React from 'react';
import { Film } from 'lucide-react';

const UnreleasedWork = () => {
  const unreleasedProjects = [
    {
      title: "Virah",
      type: "Feature Film",
      role: "Lead Actress",
      year: "In Post-Production",
      description: "Set in a Himachali village before India's partition, Virah tells a poignant tale of love, longing, and unwavering hope. A story that explores the strength of devotion tested by separation and the passage of time.",
      color: "#FF6B6B"
    },
    {
      title: "Music Video",
      type: "Music Video",
      role: "Lead Actress",
      year: "In Post-Production",
      description: "A reimagined recreation of a beloved classic, transforming a timeless melody into a visually stunning narrative. This cinematic interpretation weaves a compelling story of love, heartbreak, and longing.",
      color: "#FFD700"
    }
  ];

  return (
    <section id="unreleased" className="bg-[#0a0a0a] py-16 px-6 sm:px-8 lg:px-12">
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-10">
          <h2 className="font-display text-4xl sm:text-5xl font-black text-white mb-3">
            <span className="text-[#FF6B6B]">UNRELEASED</span> WORK
          </h2>
          <div className="w-20 h-1 bg-[#FF6B6B] mx-auto mb-3"></div>
          <p className="text-gray-400 text-sm max-w-2xl mx-auto">
            Lead roles currently in post-production
          </p>
        </div>

        {/* Compact Card List */}
        <div className="space-y-5">
          {unreleasedProjects.map((project, index) => (
            <div
              key={index}
              className="bg-[#1a1a1a] rounded-lg border border-gray-800 hover:border-gray-700 transition-all p-5"
            >
              <div className="flex items-start gap-4">
                {/* Icon */}
                <div 
                  className="w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 mt-1"
                  style={{ backgroundColor: `${project.color}20` }}
                >
                  <Film style={{ color: project.color }} size={22} />
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                  {/* Title & Badge Row */}
                  <div className="flex items-start justify-between gap-3 mb-2">
                    <div>
                      <h3 className="text-xl font-bold text-white mb-1">{project.title}</h3>
                      <p style={{ color: project.color }} className="text-sm font-semibold">
                        {project.role}
                      </p>
                    </div>
                    <div className="flex flex-col items-end gap-1 flex-shrink-0">
                      <span 
                        className="px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider whitespace-nowrap"
                        style={{ 
                          backgroundColor: `${project.color}20`,
                          color: project.color,
                          border: `1px solid ${project.color}`
                        }}
                      >
                        {project.type}
                      </span>
                      <span className="text-gray-500 text-xs">{project.year}</span>
                    </div>
                  </div>

                  {/* Description */}
                  <p className="text-gray-400 text-sm leading-relaxed">
                    {project.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom Note */}
        <div className="mt-8 text-center">
          <p className="text-gray-500 text-xs uppercase tracking-wider">
            More projects coming soon
          </p>
        </div>
      </div>
    </section>
  );
};

export default UnreleasedWork;
